module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./TakeDeliveryListView.js"));
	}, "TakeDeliveryList");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=TakeDeliveryList!./src/pages/Shop/Member/Wallet/Coupon/TakeDeliveryList/TakeDeliveryListView.js
// module id = 1093
// module chunks = 431